import { render, staticRenderFns } from "./CategoryBody.vue?vue&type=template&id=30d45fa0&lang=pug&"
import script from "./CategoryBody.vue?vue&type=script&lang=js&"
export * from "./CategoryBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports